import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { ButtonV2, EmptyState, ErrorState, ModalV2 } from 'components'
import { useGetServiceOrderInfo, useUserInfo } from 'shared/hooks'
import { handleRenderState } from 'utilities/handleRenderState'
import {
  Central,
  PowerStatus,
  SERVICE_ORDER_TYPE_ENUM,
} from 'services/serviceOrder'

import {
  EquipmentsInfo,
  ServiceOrderSnapshot,
  UninstalledEquipmentsStatus,
} from './components'
import Loading from './Loading'
import styles from './styles.module.scss'
import { ValidateSO } from '../SOInformation/containers/SODetails/components/Actions/components'
import { ATTENDANCE_ROLE } from 'services/coverages'

/* TODO Refazer todas a parte de Equipments com novos componentes e logicas, por enquanto será mantido o código antigo e feito algumas cópias/imports do antigo domínio
desconsiderar em code review =)
 */
const Equipments = () => {
  const { userInfo } = useUserInfo()
  const { serviceOrderId } = useParams()

  const { data, isLoading, isError } = useGetServiceOrderInfo(
    serviceOrderId,
    Boolean(serviceOrderId),
    true,
  )

  const hasConnectionFailure = (central: Central): boolean => {
    const hasDeviceConnectionFailure = central.partitions.some((partition) => {
      return partition.devices.some(
        (device) => device.lowBattery || device.signal === 0,
      )
    })

    const hasCentralConnectionFailure =
      !central?.gprs?.connectionStatus ||
      central?.powerStatus === PowerStatus.OFF

    return hasDeviceConnectionFailure || hasCentralConnectionFailure
  }

  const hasServiceOrderAttendantRole = useMemo(
    () =>
      userInfo?.userCoverages?.primary?.some(
        (coverage) =>
          coverage.coverageType === ATTENDANCE_ROLE.SERVICE_ORDER_ATTENDANT,
      ),
    [userInfo],
  )

  const isApproveDisabled = useMemo(
    () =>
      data?.centralInfo?.currentShadow
        ? hasConnectionFailure(data?.centralInfo?.currentShadow)
        : true,
    [data],
  )

  const centralInfoAfterSnapshot =
    data?.centralInfo?.currentShadow || data?.centralInfo?.finishedSnapshot

  const isUninstallServiceOrder =
    data?.serviceOrderInfo?.type === SERVICE_ORDER_TYPE_ENUM.UNINSTALL

  const uninstalledEquipments =
    isUninstallServiceOrder && centralInfoAfterSnapshot?.partitions.length

  const equipmentsInfo =
    !data?.centralInfo?.inProgressSnapshot &&
    !data?.centralInfo?.devicesRemoved &&
    centralInfoAfterSnapshot?.partitions.length

  const serviceOrderSnapshot = data?.centralInfo?.inProgressSnapshot

  return (
    <>
      {
        {
          view: !!data && (
            <div className={styles.container}>
              {serviceOrderSnapshot && (
                <ServiceOrderSnapshot
                  serviceOrderInfo={data}
                  /*  handleSelect={handleActionOnClick}
                  onPressGallery={handleOpenGallery} */
                />
              )}
              {equipmentsInfo && (
                <div className={styles.currentShadow}>
                  <EquipmentsInfo
                    serviceOrder={{
                      serviceOrderId: data?.id,
                      customerId: data?.serviceOrderInfo?.customer?.id,
                      accountId: data?.serviceOrderInfo?.account?.id,
                    }}
                    centralInfo={centralInfoAfterSnapshot}
                    /*      handleSelect={handleActionOnClick}
                      onPressGallery={handleOpenGallery} */
                    model={data.centralInfo?.model}
                  />
                </div>
              )}
              {uninstalledEquipments && (
                <UninstalledEquipmentsStatus
                  centralInfo={centralInfoAfterSnapshot}
                  devicesRemoved={data.centralInfo?.devicesRemoved}
                />
              )}

              {data?.serviceOrderInfo?.status === 'IN_VALIDATION' && (
                <div className={styles.actions}>
                  <ModalV2.Root>
                    <ModalV2.Trigger>
                      <ButtonV2 appearance="primary" color="red" type="button">
                        Reprovar
                      </ButtonV2>
                    </ModalV2.Trigger>
                    <ValidateSO status="DISAPPROVE" />
                  </ModalV2.Root>
                  <ModalV2.Root>
                    <ModalV2.Trigger
                      disabled={
                        (isApproveDisabled &&
                          !isUninstallServiceOrder &&
                          data.centralInfo?.hasCommandSupport) ||
                        !hasServiceOrderAttendantRole
                      }
                    >
                      <ButtonV2 appearance="primary" type="button">
                        Aprovar
                      </ButtonV2>
                    </ModalV2.Trigger>
                    <ValidateSO status="APPROVE" />
                  </ModalV2.Root>
                </div>
              )}
            </div>
          ),
          loading: <Loading />,
          error: <ErrorState />,
          empty: <EmptyState type="EmptyEquipment" />,
        }[
          handleRenderState({
            data,
            isLoading,
            isError,
            isEmpty: !data?.centralInfo?.currentCentralId,
          })
        ]
      }
    </>
  )
}

export default Equipments
